import { render, staticRenderFns } from "./FilledLikeIcon.vue?vue&type=template&id=545ed536"
import script from "./FilledLikeIcon.vue?vue&type=script&lang=ts"
export * from "./FilledLikeIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports